import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { vehicleType } from 'Utilities/helpers';

import { Content } from 'LegacySBCRA/Content/Content';

import texts from '../../../../../texts.json';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import RelatedGuides from '../../../contentPages/landingPages/RelatedGuides/RelatedGuides';
import { RelatedGuidesContentType } from '../../Pages/LandingPage.helpers';

import styles from './RelatedGuidesSection.scss';

const LocalT = new MDText(texts);

const t = (key: string, props?: { [key:string]: unknown }) => LocalT.translate(key, props) as string;

type RelatedGuidesProps = {
  guides: RelatedGuidesContentType;
  headerTitle: string;
  isFAQEmpty: boolean;
  onLoad: () => void;
  redirectToUrl: string;
};

export const RelatedGuidesSection = ({
  guides,
  headerTitle,
  isFAQEmpty,
  onLoad,
  redirectToUrl,
}: RelatedGuidesProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <div
      ref={(ref) => setRef(ref)}
      className={cx(styles.component, { [styles.greyBg]: !isFAQEmpty })}
      data-testid='relatedGuides'>
      <Content>
        <h3 className={styles.relatedGuidesTitle}>{headerTitle || t('landingPageRelatedGuides.title')}</h3>
        <div className={styles.relatedGuidesBody}>
          {
            guides.map(({ description, thumbnail, title, url }) => (
              <RelatedGuides
                key={title}
                description={description}
                thumbnail={thumbnail}
                title={title}
                url={url || ''}
              />
            ))
          }
        </div>
        <a className="mw-link mw-link-blue" href="/sell-my-car/guides">
          {t('landingPageRelatedGuides.link', {
            vehicle: vehicleType(redirectToUrl),
          })}
        </a>
      </Content>
    </div>
  );
};
